document.addEventListener('DOMContentLoaded', () => {
  const modalOverlay = document.getElementById('vto-modal-overlay');
  if (!modalOverlay) return;

  const closeBtn = document.querySelector('.vto-close-btn');
  const triggerBtns = document.querySelectorAll('.virtual-tryon-trigger');

  const uploadBtn = document.getElementById('vto-upload-btn');
  const fileInput = document.getElementById('vto-file-input');
  const cameraBtn = document.getElementById('vto-camera-btn');
  const cameraInput = document.getElementById('vto-camera-input');
  const tryAgainBtn = document.getElementById('vto-try-again-btn');
  const addToCartBtn = document.getElementById('vto-add-to-cart-btn');
  const statusText = document.getElementById('vto-status-text');
  const uploadStatusCopy = document.getElementById('vto-upload-status-copy');

  const viewConsent = document.getElementById('vto-view-consent');
  const viewUpload = document.getElementById('vto-view-upload');
  const viewScanning = document.getElementById('vto-view-scanning');
  const viewResult = document.getElementById('vto-view-result');

  const consentCheckbox = document.getElementById('vto-consent-checkbox');
  const consentContinueBtn = document.getElementById('vto-consent-continue-btn');
  const consentDeclineBtn = document.getElementById('vto-consent-decline-btn');
  const deleteTryonBtn = document.getElementById('vto-delete-tryon-btn');
  const withdrawConsentBtn = document.getElementById('vto-withdraw-consent-btn');
  const minimizeBtn = document.getElementById('vto-minimize-btn');
  const downloadBtn = document.getElementById('vto-download-btn');

  const pill = document.getElementById('vto-pill');
  const pillSpinner = document.getElementById('vto-pill-spinner');
  const pillThumb = document.getElementById('vto-pill-thumb');
  const pillText = document.getElementById('vto-pill-text');
  const pillCloseBtn = document.getElementById('vto-pill-close-btn');

  const previewImage = document.getElementById('vto-preview-image');
  const resultImage = document.getElementById('vto-result-image');

  const actionsContainer = document.getElementById('vto-actions-container');
  const remainingNote = document.getElementById('vto-remaining-note');
  const limitBox = document.getElementById('vto-limit-box');
  const limitMessage = document.getElementById('vto-limit-message');
  const limitSub = document.getElementById('vto-limit-sub');
  const loginLink = document.getElementById('vto-login-link');

  const webhookUrl = window.AIVA_TRYON_WEBHOOK_URL || 'https://n8n.srv1123091.hstgr.cloud/webhook/virtual-tryon';
  const deleteWebhookUrl = webhookUrl + '-delete';
  const vtoSettings = window.PJ_VTO_SETTINGS || {};

  // Bump this whenever the VTO privacy notice text materially changes -
  // returning visitors are shown the consent screen again on the next bump.
  const CONSENT_VERSION = 'v1';
  const CONSENT_STORAGE_KEY = 'pj_vto_consent_' + CONSENT_VERSION;

  function hasConsent() {
    try {
      return localStorage.getItem(CONSENT_STORAGE_KEY) === 'true';
    } catch (e) {
      return false; // private mode / storage blocked: always ask
    }
  }

  function setConsent() {
    try {
      localStorage.setItem(CONSENT_STORAGE_KEY, 'true');
    } catch (e) { /* private mode */ }
  }

  function clearConsent() {
    try {
      localStorage.removeItem(CONSENT_STORAGE_KEY);
    } catch (e) { /* private mode */ }
  }

  // Set from the start-workflow response once a real try-on is submitted;
  // scoped to this page load only, never persisted (except mirrored into the
  // sessionStorage session below once a real generation is in flight).
  let currentUsageKey = '';
  let currentUsageDay = '';
  let currentTaskId = '';

  // ----- Cross-page session (minimize/maximize) -----
  // A session only exists once a real generation has been submitted (has a
  // taskId) - the consent/upload screens never persist across pages.
  const SESSION_KEY = 'pj_vto_session';

  function saveSession(patch) {
    try {
      const existing = loadSession() || {};
      const merged = Object.assign(existing, patch, { updatedAt: Date.now() });
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(merged));
      return merged;
    } catch (e) {
      return null; // private mode / storage blocked
    }
  }

  function loadSession() {
    try {
      const raw = sessionStorage.getItem(SESSION_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function clearSession() {
    try { sessionStorage.removeItem(SESSION_KEY); } catch (e) { /* private mode */ }
  }

  function showPill(stage, resultUrl) {
    if (!pill) return;
    pill.classList.remove('vto-pill-error');
    if (stage === 'result') {
      if (pillSpinner) pillSpinner.classList.add('vto-hidden');
      if (pillThumb) {
        if (resultUrl) { pillThumb.src = resultUrl; pillThumb.classList.remove('vto-hidden'); }
        else pillThumb.classList.add('vto-hidden');
      }
      if (pillText) pillText.textContent = pill.getAttribute('data-ready-text') || 'Your try-on is ready!';
    } else {
      if (pillSpinner) pillSpinner.classList.remove('vto-hidden');
      if (pillThumb) pillThumb.classList.add('vto-hidden');
      if (pillText) pillText.textContent = pill.getAttribute('data-processing-text') || 'Preparing your look...';
    }
    pill.classList.remove('vto-hidden');
    pill.classList.remove('vto-pill-enter');
    void pill.offsetWidth; // restart the entrance animation on every show
    pill.classList.add('vto-pill-enter');
  }

  // A failed generation shouldn't just vanish if the user isn't looking at
  // the modal - show a visible (dismissible) error state instead.
  function showPillError() {
    if (!pill) return;
    if (pillSpinner) pillSpinner.classList.add('vto-hidden');
    if (pillThumb) pillThumb.classList.add('vto-hidden');
    if (pillText) pillText.textContent = pill.getAttribute('data-error-text') || 'Something went wrong';
    pill.classList.add('vto-pill-error');
    pill.classList.remove('vto-hidden');
    pill.classList.remove('vto-pill-enter');
    void pill.offsetWidth;
    pill.classList.add('vto-pill-enter');
  }

  function hidePill() {
    if (pill) pill.classList.add('vto-hidden');
  }

  function settingNumber(key, fallback, min, max) {
    const value = Number(vtoSettings[key]);
    if (!Number.isFinite(value)) return fallback;
    return Math.min(max, Math.max(min, value));
  }

  function copy(key, fallback) {
    const value = vtoSettings[key];
    return (typeof value === 'string' && value.trim()) ? value : fallback;
  }

  function formatCopy(template, values) {
    return template.replace(/\{([a-z0-9_]+)\}/gi, (_, key) => {
      const value = values[key];
      return value === undefined || value === null ? '' : String(value);
    });
  }

  const isLoggedIn = modalOverlay.getAttribute('data-logged-in') === 'true';
  const loginUrl = modalOverlay.getAttribute('data-login-url') || '/account/login';
  const GUEST_LIMIT = settingNumber('guestDailyLimit', 2, 0, 20);
  const CUSTOMER_LIMIT = settingNumber('customerDailyLimit', 5, 0, 50);
  const dailyLimit = isLoggedIn ? CUSTOMER_LIMIT : GUEST_LIMIT;
  const MAX_UPLOAD_MB = settingNumber('maxUploadMb', 8, 1, 25);
  const MAX_UPLOAD_DIM = settingNumber('maxUploadDimension', 1280, 640, 2048);
  const POLL_INTERVAL_MS = settingNumber('pollIntervalMs', 2500, 1000, 10000);
  const MAX_POLL_ATTEMPTS = settingNumber('maxPollAttempts', 120, 20, 180);

  function copyVars(extra) {
    return Object.assign({
      guest_limit: GUEST_LIMIT,
      customer_limit: CUSTOMER_LIMIT,
      daily_limit: dailyLimit,
      max_upload_mb: MAX_UPLOAD_MB
    }, extra || {});
  }

  // Auto-retry when the AI returns the customer's own photo essentially
  // unchanged (a known intermittent failure of the image-to-image model).
  const MAX_GEN_ATTEMPTS = settingNumber('maxGenerationAttempts', 3, 1, 5);
  const UNCHANGED_LUMA_THRESHOLD = 9;     // mean 0-255 luma diff below this = garment not applied
  let currentFile = null;                 // prepared photo, reused for retries
  let customerPreviewDataUrl = '';        // local dataURL of the photo, for comparison
  let generationAttempt = 0;

  if (vtoSettings.enabled === false) {
    triggerBtns.forEach(btn => { btn.hidden = true; });
    return;
  }

  function getClientId() {
    try {
      let cid = localStorage.getItem('pj_vto_cid');
      if (!cid) {
        cid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : ('cid-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10));
        localStorage.setItem('pj_vto_cid', cid);
      }
      return cid;
    } catch (e) {
      return '';
    }
  }

  function todayKey() {
    return new Date().toISOString().slice(0, 10);
  }

  // Local mirror of the server-side quota, for display only. The n8n webhook
  // is the source of truth and re-syncs this on every response.
  function getLocalRemaining() {
    try {
      const raw = localStorage.getItem('pj_vto_quota');
      if (!raw) return null;
      const q = JSON.parse(raw);
      if (q.day !== todayKey() || q.loggedIn !== isLoggedIn) return null;
      return typeof q.remaining === 'number' ? q.remaining : null;
    } catch (e) {
      return null;
    }
  }

  function setLocalRemaining(remaining) {
    try {
      localStorage.setItem('pj_vto_quota', JSON.stringify({ day: todayKey(), loggedIn: isLoggedIn, remaining: remaining }));
    } catch (e) { /* private mode */ }
  }

  // dataLayer is not a private channel - never pass image URLs, blobs, or
  // dataURLs into this. Metadata only (ids, counts, timestamps, error text).
  function trackVto(eventName, payload) {
    if (typeof window.pjTrackEvent !== 'function') return;
    window.pjTrackEvent(eventName, Object.assign({
      feature: 'virtual_try_on',
      product_id: modalOverlay.getAttribute('data-product-id') || '',
      product_title: modalOverlay.getAttribute('data-product-title') || '',
      variant_id: modalOverlay.getAttribute('data-variant-id') || ''
    }, payload || {}));
  }

  // Keep the modal's variant in sync with the selected variant on the page.
  function syncVariantFromForm() {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = form && form.querySelector('[name="id"]');
    if (idInput && idInput.value) {
      modalOverlay.setAttribute('data-variant-id', idInput.value);
    }
  }

  function renderRemainingLegacy() {
    if (!remainingNote) return;
    const r = getLocalRemaining();
    if (r !== null && r <= 0) {
      showLimitReached({ requires_login: !isLoggedIn });
      return;
    }
    showActions();
    if (r !== null) {
      remainingNote.textContent = formatCopy(copy('remainingCountText', '✨ {remaining} of {daily_limit} free try-ons left today'), copyVars({ remaining: r }));
    } else if (isLoggedIn) {
      remainingNote.textContent = formatCopy(copy('remainingCustomerText', '✨ {customer_limit} free try-ons every day'), copyVars());
    } else {
      remainingNote.textContent = formatCopy(copy('remainingGuestText', '✨ {guest_limit} free try-ons today - sign in for {customer_limit} daily'), copyVars());
    }
    remainingNote.classList.remove('vto-hidden');
  }

  function showActions() {
    if (actionsContainer) actionsContainer.classList.remove('vto-hidden');
    if (limitBox) limitBox.classList.add('vto-hidden');
  }

  function showLimitReachedLegacy(payload) {
    setLocalRemaining(0);
    if (actionsContainer) actionsContainer.classList.add('vto-hidden');
    if (remainingNote) remainingNote.classList.add('vto-hidden');
    if (!limitBox) return;
    limitBox.classList.remove('vto-hidden');
    const needsLogin = payload && payload.requires_login;
    if (limitMessage) {
      limitMessage.textContent = needsLogin
        ? formatCopy(copy('limitGuestMessage', 'You have used your {guest_limit} free try-ons for today.'), copyVars())
        : formatCopy(copy('limitCustomerMessage', 'You have used your {customer_limit} try-ons for today.'), copyVars());
    }
    if (loginLink) {
      if (needsLogin) {
        loginLink.href = loginUrl + '?return_to=' + encodeURIComponent(window.location.pathname);
        loginLink.classList.remove('vto-hidden');
      } else {
        loginLink.classList.add('vto-hidden');
      }
    }
    if (limitSub) {
      limitSub.textContent = needsLogin
        ? copy('limitGuestSubtext', 'Or come back tomorrow for more ✨')
        : copy('limitCustomerSubtext', 'Come back tomorrow for more ✨');
    }
    trackVto('vto_limit_reached', { requires_login: !!needsLogin });
  }

  function renderRemaining() {
    if (!remainingNote) return;
    const r = getLocalRemaining();
    if (r !== null && r <= 0) {
      showLimitReached({ requires_login: !isLoggedIn });
      return;
    }
    showActions();
    if (r !== null) {
      remainingNote.textContent = formatCopy(
        copy('remainingCountText', '✨ {remaining} of {daily_limit} free try-ons left today'),
        copyVars({ remaining: r })
      );
    } else if (isLoggedIn) {
      remainingNote.textContent = formatCopy(
        copy('remainingCustomerText', '✨ {customer_limit} free try-ons every day'),
        copyVars()
      );
    } else {
      remainingNote.textContent = formatCopy(
        copy('remainingGuestText', '✨ {guest_limit} free try-ons today - sign in for {customer_limit} daily'),
        copyVars()
      );
    }
    remainingNote.classList.remove('vto-hidden');
  }

  function showLimitReached(payload) {
    setLocalRemaining(0);
    if (actionsContainer) actionsContainer.classList.add('vto-hidden');
    if (remainingNote) remainingNote.classList.add('vto-hidden');
    if (!limitBox) return;
    limitBox.classList.remove('vto-hidden');

    const needsLogin = payload && payload.requires_login;
    if (limitMessage) {
      limitMessage.textContent = formatCopy(
        needsLogin
          ? copy('limitGuestMessage', 'You have used your {guest_limit} free try-ons for today.')
          : copy('limitCustomerMessage', 'You have used your {customer_limit} try-ons for today.'),
        copyVars()
      );
    }
    if (loginLink) {
      if (needsLogin) {
        loginLink.href = loginUrl + '?return_to=' + encodeURIComponent(window.location.pathname);
        loginLink.textContent = formatCopy(copy('loginButtonText', 'Sign in for {customer_limit} daily try-ons'), copyVars());
        loginLink.classList.remove('vto-hidden');
      } else {
        loginLink.classList.add('vto-hidden');
      }
    }
    if (limitSub) {
      limitSub.textContent = formatCopy(
        needsLogin
          ? copy('limitGuestSubtext', 'Or come back tomorrow for more ✨')
          : copy('limitCustomerSubtext', 'Come back tomorrow for more ✨'),
        copyVars()
      );
    }
    trackVto('vto_limit_reached', { requires_login: !!needsLogin });
  }

  // ----- Modal open/minimize/maximize/close -----

  function openModal() {
    syncVariantFromForm();
    modalOverlay.classList.remove('vto-hidden');
    document.documentElement.classList.add('vto-lock-scroll');
    resetModal();
    renderRemaining();
    if (closeBtn) closeBtn.focus({ preventScroll: true });
    trackVto('vto_open');
  }

  // Hides the modal but keeps any in-flight generation running in the
  // background (polling is not cleared) - the floating tab takes over.
  function minimizeModal() {
    modalOverlay.classList.add('vto-hidden');
    document.documentElement.classList.remove('vto-lock-scroll');
    const session = saveSession({ minimized: true });
    if (session && session.stage) showPill(session.stage, session.resultImageUrl);
    trackVto('vto_minimize');
  }

  // Reopens the modal from the floating tab, on this page or any other -
  // restores from the stored session rather than the current page's product.
  function maximizeSession() {
    const session = loadSession();
    modalOverlay.classList.remove('vto-hidden');
    document.documentElement.classList.add('vto-lock-scroll');
    saveSession({ minimized: false });
    hidePill();
    if (session) {
      if (session.taskId) currentTaskId = session.taskId;
      if (session.usageKey) currentUsageKey = session.usageKey;
      if (session.day) currentUsageDay = session.day;
    }
    if (session && session.stage === 'result' && session.resultImageUrl) {
      resultImage.src = session.resultImageUrl;
      switchView(viewResult);
    } else if (session && session.stage === 'processing') {
      switchView(viewScanning);
    } else {
      resetModal();
    }
    trackVto('vto_maximize');
  }

  // Full stop: clears any in-flight polling and the cross-page session.
  function closeModal() {
    modalOverlay.classList.add('vto-hidden');
    document.documentElement.classList.remove('vto-lock-scroll');
    clearInterval(animationInterval);
    clearInterval(pollingInterval);
    clearSession();
    hidePill();
  }

  triggerBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const session = loadSession();
      if (session && session.taskId && (session.stage === 'processing' || session.stage === 'result')) {
        maximizeSession();
      } else {
        openModal();
      }
    });
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (minimizeBtn) minimizeBtn.addEventListener('click', minimizeModal);

  if (pill) {
    pill.addEventListener('click', (e) => {
      if (e.target === pillCloseBtn) {
        e.stopPropagation();
        closeModal();
        return;
      }
      if (pill.classList.contains('vto-pill-error')) {
        // Nothing to resume after a failed generation - dismiss and let
        // them start fresh instead of trying to restore a broken state.
        closeModal();
        openModal();
        return;
      }
      maximizeSession();
    });
  }

  // Clicking outside the modal keeps progress alive instead of abandoning it.
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) minimizeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modalOverlay.classList.contains('vto-hidden')) minimizeModal();
  });

  if (uploadBtn) uploadBtn.addEventListener('click', () => fileInput.click());
  if (cameraBtn) cameraBtn.addEventListener('click', () => cameraInput.click());
  if (tryAgainBtn) tryAgainBtn.addEventListener('click', () => { resetModal(); renderRemaining(); });

  // ----- Consent screen -----

  if (consentCheckbox && consentContinueBtn) {
    consentCheckbox.addEventListener('change', () => {
      consentContinueBtn.disabled = !consentCheckbox.checked;
    });
  }

  if (consentContinueBtn) {
    consentContinueBtn.addEventListener('click', () => {
      if (consentCheckbox && !consentCheckbox.checked) return;
      setConsent();
      trackVto('vto_consent_given', { consent_version: CONSENT_VERSION });
      switchView(viewUpload);
      renderRemaining();
    });
  }

  if (consentDeclineBtn) {
    consentDeclineBtn.addEventListener('click', () => closeModal());
  }

  // ----- Delete / withdraw consent -----
  // Kie.ai has no self-serve delete API (see Privacy Notice): this can only
  // remove the records under Pretty J's own control right away and notify a
  // human to chase anything still held by Kie.ai on its own schedule.

  async function requestDeletion() {
    // Nothing to delete server-side yet in this session (e.g. consent was
    // withdrawn before any photo was ever submitted) - nothing to confirm.
    if (!currentUsageKey) return true;

    const confirmText = modalOverlay.getAttribute('data-delete-confirm-text') || 'Delete your saved try-on data now?';
    if (!window.confirm(confirmText)) return false;

    trackVto('vto_delete_requested', { has_task_id: !!currentTaskId });

    try {
      const response = await fetch(deleteWebhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          usage_key: currentUsageKey,
          day: currentUsageDay,
          task_id: currentTaskId
        })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.success === false) throw new Error(result.error || 'Delete request failed');
      window.alert(modalOverlay.getAttribute('data-delete-success-text') || 'Your try-on data has been deleted.');
      currentUsageKey = '';
      currentUsageDay = '';
      currentTaskId = '';
      return true;
    } catch (e) {
      window.alert(modalOverlay.getAttribute('data-delete-error-text') || "We couldn't delete your data right now. Please try again or email hello@prettyj.store.");
      return false;
    }
  }

  if (deleteTryonBtn) {
    deleteTryonBtn.addEventListener('click', requestDeletion);
  }

  if (withdrawConsentBtn) {
    withdrawConsentBtn.addEventListener('click', async () => {
      const hadUsageKey = !!currentUsageKey;
      const deleted = await requestDeletion();
      if (!deleted) return; // user cancelled the confirm, or the delete call failed - leave consent as-is
      clearConsent();
      if (!hadUsageKey) {
        // Nothing was sent to the server; requestDeletion() showed no alert
        // of its own, so confirm the (local) consent withdrawal here.
        window.alert(modalOverlay.getAttribute('data-consent-withdrawn-text') || 'Consent withdrawn. You will be asked again next time.');
      }
      resetModal();
    });
  }

  // Add to Cart. Fast path: click the real product form's submit button so
  // Dawn's AJAX cart (drawer/notification) runs - only valid when we're
  // still on the same product's page the session started on. Otherwise
  // (resumed on a different page) fall back to the Shopify AJAX Cart API,
  // which works from anywhere.
  async function addToCartAjax(variantId) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      return response.ok;
    } catch (e) {
      return false;
    }
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async () => {
      const session = loadSession();
      const variantId = (session && session.variantId) || modalOverlay.getAttribute('data-variant-id');
      const currentProductId = modalOverlay.getAttribute('data-product-id');
      const sameProductPage = !session || !session.productId || session.productId === currentProductId;
      const form = sameProductPage ? document.querySelector('form[data-type="add-to-cart-form"]') : null;
      const submitBtn = form && form.querySelector('button[type="submit"], input[type="submit"]');

      trackVto('vto_add_to_cart');

      if (submitBtn && !submitBtn.disabled) {
        closeModal();
        submitBtn.click();
        return;
      }

      const ok = await addToCartAjax(variantId);
      closeModal();
      if (ok) {
        window.location.href = '/cart';
      } else {
        window.alert('Could not add to cart. Please try again from the product page.');
      }
    });
  }

  // Download the generated result image. Tries a real download (blob) first;
  // falls back to opening it in a new tab if Kie's CDN blocks cross-origin
  // fetch, so the user can still save it manually.
  if (downloadBtn) {
    downloadBtn.addEventListener('click', async () => {
      const url = resultImage.src;
      if (!url) return;
      trackVto('vto_download_result');
      try {
        const resp = await fetch(url, { mode: 'cors' });
        if (!resp.ok) throw new Error('fetch failed');
        const blob = await resp.blob();
        const objUrl = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objUrl;
        a.download = 'pretty-j-virtual-try-on.jpg';
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(objUrl), 1000);
      } catch (e) {
        const a = document.createElement('a');
        a.href = url;
        a.download = 'pretty-j-virtual-try-on.jpg';
        a.target = '_blank';
        a.rel = 'noopener';
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    });
  }

  // ----- Image preparation (client-side downscale) -----

  // Downscale before upload: a phone photo is 3-8MB; at 1280px JPEG it is
  // ~200-400KB, which cuts both upload legs (browser->n8n->Kie) and Kie's
  // own preprocessing time.
  async function prepareImage(file) {
    try {
      let bitmap;
      try {
        bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
      } catch (optErr) {
        bitmap = await createImageBitmap(file);
      }
      const largest = Math.max(bitmap.width, bitmap.height);
      const scale = Math.min(1, MAX_UPLOAD_DIM / largest);
      if (scale >= 1 && file.size <= 2 * 1024 * 1024) {
        bitmap.close && bitmap.close();
        return file;
      }
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(bitmap.width * scale);
      canvas.height = Math.round(bitmap.height * scale);
      const ctx = canvas.getContext('2d');
      ctx.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      bitmap.close && bitmap.close();
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.85));
      if (!blob) return file;
      return new File([blob], 'customer-photo.jpg', { type: 'image/jpeg' });
    } catch (e) {
      return file; // fall back to the original; server still validates size
    }
  }

  async function handleFile(file, source) {
    if (!file) return;

    if (file.size > MAX_UPLOAD_MB * 1024 * 1024) {
      if (statusText) statusText.classList.add('vto-status-error');
      if (uploadStatusCopy) {
        uploadStatusCopy.innerText = formatCopy(
          copy('uploadTooLargeText', 'Image is too large. Please select an image under {max_upload_mb}MB.'),
          copyVars()
        );
      }
      trackVto('vto_error', { error_type: 'file_too_large', source: source });
      return;
    }

    trackVto('vto_upload_selected', { file_size: file.size, file_type: file.type, source: source });

    const prepared = await prepareImage(file);

    const reader = new FileReader();
    reader.onload = (e) => {
      customerPreviewDataUrl = e.target.result;
      previewImage.src = e.target.result;
      currentFile = prepared;
      generationAttempt = 0;
      startTryOnFlow(prepared);
    };
    reader.readAsDataURL(prepared);
  }

  fileInput.addEventListener('change', (e) => handleFile(e.target.files[0], 'upload'));
  if (cameraInput) cameraInput.addEventListener('change', (e) => handleFile(e.target.files[0], 'camera'));

  // ----- Generation flow -----

  const dynamicText = document.getElementById('vto-dynamic-text');
  const progressPie = document.getElementById('vto-progress-pie');
  const progressPercent = document.getElementById('vto-progress-percent');
  const skeletonPanel = document.getElementById('vto-skeleton-panel');
  const subText = document.getElementById('vto-sub-text');
  let pollingInterval;
  let animationInterval;
  let progressValue = 0;
  let pollAttempts = 0;

  const waitingMessages = [
    copy('waitingMessage1', 'Analyzing body posture...'),
    copy('waitingMessage2', 'Stitching digital fabric...'),
    copy('waitingMessage3', 'Adjusting lighting...'),
    copy('waitingMessage4', 'Matching colors...'),
    copy('waitingMessage5', 'Applying final touches...')
  ].filter(Boolean);

  async function startTryOnFlow(file) {
    generationAttempt += 1;
    const isRetry = generationAttempt > 1;
    switchView(viewScanning);
    trackVto('vto_generation_start', { attempt: generationAttempt });

    // Product context is needed for both the upload request below AND the
    // cross-page session - captured here (not after the fetch) so minimizing
    // during the few hundred ms before the server responds still has
    // something to show the pill from, instead of a silent no-op.
    const productId = modalOverlay.getAttribute('data-product-id');
    const productTitle = modalOverlay.getAttribute('data-product-title');
    const variantId = modalOverlay.getAttribute('data-variant-id');
    const productImage = modalOverlay.getAttribute('data-product-image');
    const productHandle = window.location.pathname.split('/').pop();
    const productUrl = window.location.href;

    saveSession({
      stage: 'processing',
      minimized: false,
      taskId: '',
      usageKey: currentUsageKey,
      day: currentUsageDay,
      productId: productId,
      variantId: variantId,
      productTitle: productTitle,
      productUrl: productUrl,
      productImageUrl: productImage,
      resultImageUrl: ''
    });

    let msgIndex = 0;
    pollAttempts = 0;
    if (dynamicText) dynamicText.innerText = isRetry ? copy('retryLoadingText', 'Refining your look...') : copy('initialLoadingText', 'Uploading photo...');
    if (subText) subText.innerText = isRetry ? copy('retrySubtext', 'Getting the fit just right.') : copy('processingWaitCopy', 'This usually takes 1-2 minutes.');
    if (skeletonPanel) skeletonPanel.classList.remove('vto-error-state');
    setProgress(isRetry ? 20 : 5);

    animationInterval = setInterval(() => {
      if (dynamicText) {
        dynamicText.classList.remove('vto-text-fade');
        void dynamicText.offsetWidth; // Trigger reflow
        dynamicText.innerText = waitingMessages[msgIndex % waitingMessages.length] || copy('initialLoadingText', 'Uploading photo...');
        dynamicText.classList.add('vto-text-fade');
        msgIndex++;
      }
      if (progressValue < 92) {
        setProgress(progressValue + Math.max(2, (92 - progressValue) * 0.16));
      }
    }, 2500);

    const formData = new FormData();
    formData.append('customer_image', file);
    formData.append('product_id', productId || '');
    formData.append('product_title', productTitle || '');
    formData.append('variant_id', variantId || '');
    formData.append('product_image_url', productImage || '');
    formData.append('product_handle', productHandle || '');
    formData.append('product_url', productUrl || '');
    formData.append('product_type', modalOverlay.getAttribute('data-product-type') || '');
    formData.append('product_tags', modalOverlay.getAttribute('data-product-tags') || '');
    formData.append('vto_category', modalOverlay.getAttribute('data-vto-category') || '');
    formData.append('customer_id', modalOverlay.getAttribute('data-customer-id') || '');
    formData.append('logged_in', isLoggedIn ? 'true' : 'false');
    formData.append('client_id', getClientId());
    formData.append('attempt', String(generationAttempt));
    formData.append('is_retry', isRetry ? 'true' : 'false');
    formData.append('ui_model_slug', vtoSettings.modelSlug || '');
    formData.append('consent_version', CONSENT_VERSION);

    let allImages = null;
    try {
      allImages = JSON.parse(modalOverlay.getAttribute('data-product-images') || 'null');
    } catch (e) { allImages = null; }
    if (!Array.isArray(allImages) || allImages.length === 0) {
      allImages = (window.productImages && Array.isArray(window.productImages)) ? window.productImages : [productImage];
    }
    formData.append('all_product_images', JSON.stringify(allImages));

    try {
      const response = await fetch(webhookUrl, { method: 'POST', body: formData });
      if (!response.ok) throw new Error('Server error: ' + response.status);
      const result = await response.json();

      if (typeof result.remaining === 'number') setLocalRemaining(result.remaining);
      if (result.usage_key) currentUsageKey = result.usage_key;
      if (result.day) currentUsageDay = result.day;

      if (result.success && result.taskId) {
        currentTaskId = result.taskId;
        saveSession({ taskId: result.taskId, usageKey: currentUsageKey, day: currentUsageDay });
        setProgress(18);
        trackVto('vto_generation_queued', { task_id: result.taskId, model_slug: result.model_slug || '' });
        pollStatus(result.taskId);
      } else if (result.success && result.result_image_url) {
        clearInterval(animationInterval);
        saveSession({ usageKey: currentUsageKey, day: currentUsageDay });
        finishWithResult(result.result_image_url, 'immediate');
      } else if (result.error_code === 'LIMIT_REACHED') {
        clearInterval(animationInterval);
        clearSession(); // the optimistic session created above never actually started
        hidePill();
        switchView(viewUpload);
        showLimitReached(result);
      } else {
        // result.error may contain raw backend/Kie text - log it, but never
        // display it directly (see handleError).
        throw new Error(result.error || 'start_failed');
      }
    } catch (error) {
      handleError(error, copy('startErrorText', 'Failed to start generation.'));
    }
  }

  async function pollStatus(taskId) {
    const statusUrl = webhookUrl + '-status?taskId=' + encodeURIComponent(taskId);
    let consecutivePollErrors = 0;
    const MAX_POLL_ERRORS = 4; // tolerate transient network/CORS blips before giving up

    pollingInterval = setInterval(async () => {
      pollAttempts += 1;
      // Image edit models can run ~90-150s. The configured cap keeps a
      // stalled task never spins forever.
      if (pollAttempts > MAX_POLL_ATTEMPTS) {
        clearInterval(pollingInterval);
        handleError(new Error('poll_timeout'), copy('timeoutErrorText', 'The result is taking longer than expected. Please try again.'));
        return;
      }
      try {
        const response = await fetch(statusUrl, { method: 'GET' });
        if (!response.ok) {
          consecutivePollErrors = 0; // server reachable; keep polling through 5xx
          return;
        }
        const data = await response.json();
        consecutivePollErrors = 0;

        if (data.status === 'COMPLETED' || data.status === 'SUCCESS' || data.result_image_url) {
          clearInterval(pollingInterval);
          clearInterval(animationInterval);
          finishWithResult(data.result_image_url, 'polled');
        } else if (data.status === 'FAILED') {
          clearInterval(pollingInterval);
          // data.error may contain raw Kie/backend text - log only, never display.
          handleError(new Error(data.error || 'generation_failed'), copy('generationFailedText', 'Generation failed at AI level.'));
        }
        // PROCESSING or any other status: keep polling
      } catch (err) {
        // A single failed fetch (network hiccup) should not kill a good
        // generation; only give up after several consecutive failures.
        consecutivePollErrors += 1;
        if (consecutivePollErrors >= MAX_POLL_ERRORS) {
          clearInterval(pollingInterval);
          handleError(err, copy('unavailableErrorText', "Due to high traffic, this isn't available right now. Please try again shortly."));
        }
      }
    }, POLL_INTERVAL_MS);
  }

  function loadComparableImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }

  // Mean luma difference (0-255) between two images downscaled to 32x32.
  // A real try-on changes a large area of the image (typically >15); the
  // "returned my own photo unchanged" failure scores near 0-4.
  async function lumaDiff(srcA, srcB) {
    const N = 32;
    const pair = await Promise.all([loadComparableImage(srcA), loadComparableImage(srcB)]);
    const canvas = document.createElement('canvas');
    canvas.width = N;
    canvas.height = N;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(pair[0], 0, 0, N, N);
    const da = ctx.getImageData(0, 0, N, N).data;
    ctx.clearRect(0, 0, N, N);
    ctx.drawImage(pair[1], 0, 0, N, N);
    const db = ctx.getImageData(0, 0, N, N).data;
    let sum = 0;
    for (let i = 0; i < da.length; i += 4) {
      const la = 0.299 * da[i] + 0.587 * da[i + 1] + 0.114 * da[i + 2];
      const lb = 0.299 * db[i] + 0.587 * db[i + 1] + 0.114 * db[i + 2];
      sum += Math.abs(la - lb);
    }
    return sum / (N * N);
  }

  // Show the result unless the AI handed back the customer's own photo
  // unchanged, in which case silently regenerate (retries do not cost the
  // customer a try-on) up to MAX_GEN_ATTEMPTS.
  async function finishWithResult(url, mode) {
    if (!url) { handleError(new Error('no_result_url'), copy('noResultText', 'No result image returned.')); return; }

    let diff = null;
    try {
      if (customerPreviewDataUrl) diff = await lumaDiff(customerPreviewDataUrl, url);
    } catch (e) {
      diff = null; // could not compare (e.g. CDN hiccup) - trust the result
    }
    const unchanged = diff !== null && diff < UNCHANGED_LUMA_THRESHOLD;
    const roundedDiff = diff === null ? null : Math.round(diff * 100) / 100;

    if (unchanged) {
      if (generationAttempt < MAX_GEN_ATTEMPTS && currentFile) {
        trackVto('vto_unchanged_retry', { attempt: generationAttempt, luma_diff: roundedDiff });
        startTryOnFlow(currentFile);
        return;
      }
      // Out of retries and still unchanged: guide the user rather than show their own photo back.
      trackVto('vto_unchanged_giveup', { attempts: generationAttempt, luma_diff: roundedDiff });
      handleError(new Error('unchanged_result'), copy('unchangedResultText', 'We could not place this item on your photo. Please try a clear, front-facing full-body photo.'));
      return;
    }

    setProgress(100);
    setTimeout(() => {
      resultImage.src = url;
      switchView(viewResult);
      saveSession({ stage: 'result', resultImageUrl: url });
      if (pill && !pill.classList.contains('vto-hidden')) showPill('result', url);
      trackVto('vto_generation_success', { mode: mode, attempts: generationAttempt, luma_diff: roundedDiff });
    }, 400);
  }

  // `error` is logged in full for debugging (console + analytics event) but
  // NEVER shown to the shopper - only `friendlyMessage` (or the generic
  // fallback below) reaches the screen. Raw backend/network error text
  // (timeouts, Kie failures, HTTP status text, etc.) must never leak to the UI.
  function handleError(error, friendlyMessage) {
    clearInterval(animationInterval);
    clearInterval(pollingInterval);
    console.error('Virtual Try-On Error:', error);
    const message = friendlyMessage || copy('unavailableErrorText', "Due to high traffic, this isn't available right now. Please try again shortly.");
    const wasMinimized = pill && !pill.classList.contains('vto-hidden');
    clearSession();
    if (wasMinimized) {
      showPillError();
    } else {
      hidePill();
    }
    if (skeletonPanel) skeletonPanel.classList.add('vto-error-state');
    setProgress(100);
    if (dynamicText) dynamicText.innerText = copy('genericErrorTitle', 'We could not finish this try-on.');
    if (subText) subText.innerText = message;
    trackVto('vto_error', { error_message: error && error.message ? error.message : 'Unknown VTO error' });
  }

  function switchView(activeView) {
    [viewConsent, viewUpload, viewScanning, viewResult].forEach(view => {
      if (view) view.classList.remove('vto-view-active');
    });
    if (activeView) activeView.classList.add('vto-view-active');
  }

  function resetModal() {
    clearInterval(animationInterval);
    clearInterval(pollingInterval);
    pollAttempts = 0;
    clearSession();
    hidePill();
    switchView(hasConsent() ? viewUpload : viewConsent);
    fileInput.value = '';
    if (cameraInput) cameraInput.value = '';
    previewImage.src = '';
    if (skeletonPanel) skeletonPanel.classList.remove('vto-error-state');
    if (statusText) statusText.classList.remove('vto-status-error');
    if (uploadStatusCopy) uploadStatusCopy.innerText = copy('secureNoteText', 'Your photos are processed securely.');
    setProgress(0);
    if (dynamicText) dynamicText.innerText = copy('resetLoadingText', 'Creating your look...');
    if (subText) subText.innerText = copy('processingWaitCopy', 'This usually takes 1-2 minutes.');
  }

  function setProgress(value) {
    progressValue = Math.max(0, Math.min(100, Math.round(value)));
    if (progressPie) progressPie.style.setProperty('--vto-progress', progressValue);
    if (progressPercent) progressPercent.innerText = progressValue + '%';
  }

  // ----- Resume a session that survived a page navigation -----
  // Runs on every page load (the modal/script are site-wide). Never
  // auto-opens the full modal on a page the user didn't explicitly reopen it
  // on - only the floating tab appears, and polling resumes silently.
  (function resumeSession() {
    const session = loadSession();
    if (!session || !session.taskId) return;
    currentTaskId = session.taskId;
    currentUsageKey = session.usageKey || '';
    currentUsageDay = session.day || '';
    if (session.stage === 'result') {
      showPill('result', session.resultImageUrl);
    } else if (session.stage === 'processing') {
      showPill('processing');
      pollStatus(session.taskId);
    }
  })();
});
